import { render, staticRenderFns } from "./numberTips.vue?vue&type=template&id=cc9c969c&scoped=true"
import script from "./numberTips.vue?vue&type=script&lang=js"
export * from "./numberTips.vue?vue&type=script&lang=js"
import style0 from "./numberTips.vue?vue&type=style&index=0&id=cc9c969c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9c969c",
  null
  
)

export default component.exports